import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box
} from '@mui/material';
import SimulationFormFields from './SimulationFormFields';
import { UseCreateSimulationReturn } from '../../../hooks/useCreateSimulation';

export interface CreateSimulationFormProps extends Pick<
  UseCreateSimulationReturn,
  | 'formErrors'
  | 'platforms'
  | 'accounts'
  | 'handleInputChange'
  | 'handleSelectChange'
  | 'handleImageChange'
  | 'handleSubmit'
  | 'state'
  | 'dispatch'
  | 'orgInfo'
> {}

const CreateSimulationForm: React.FC<CreateSimulationFormProps> = ({
  formErrors,
  platforms,
  accounts,
  handleInputChange,
  handleSelectChange,
  handleImageChange,
  handleSubmit,
  state,
  dispatch,
  orgInfo
}) => {
  const handlePrivateChange = (checked: boolean) => {
    dispatch({ 
      type: 'UPDATE_FORM', 
      payload: { isPrivate: checked } 
    });
  };

  const isSubmitDisabled = state.isLoading || Boolean(
    orgInfo && 
    orgInfo.plan !== 'INTERNAL' && 
    ((orgInfo.monthlySimQuota || 0) - (orgInfo.simUsed || 0) <= 0)
  );

  return (
    <Box sx={{ maxWidth: 'md', mx: 'auto', px: { xs: 2, sm: 0 } }}>
      <form onSubmit={handleSubmit}>
        <Card sx={{ mb: 4 }}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Typography variant="h6" gutterBottom>
              Content Details
            </Typography>
            
            <SimulationFormFields
              formData={state.formData}
              formErrors={formErrors}
              platforms={platforms}
              accounts={accounts}
              handleInputChange={handleInputChange}
              handleSelectChange={handleSelectChange}
              handleImageChange={handleImageChange}
              handlePrivateChange={handlePrivateChange}
            />
          </CardContent>
        </Card>
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 4 }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large" 
            type="submit"
            disabled={isSubmitDisabled}
          >
            {state.isLoading ? 'Processing...' : 'Run Simulation'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreateSimulationForm;